import { render, staticRenderFns } from "./rysUserAgreement.vue?vue&type=template&id=4d79d8d3&scoped=true"
import script from "./rysUserAgreement.vue?vue&type=script&lang=js"
export * from "./rysUserAgreement.vue?vue&type=script&lang=js"
import style0 from "./rysUserAgreement.vue?vue&type=style&index=0&id=4d79d8d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79d8d3",
  null
  
)

export default component.exports